export const handleImportPsd = (_message, { commit, dispatch } = {}) => {
  if (commit) {
    commit('SET_PENDING_PSD_IMPORT', true);

    dispatch('addAndSaveMessage', {
      role: 'assistant',
      content: 'Please attach a PSD file and send your resize request. Include the target dimensions in the message or select sizes below. You can also add a hint such as “Keep the logo in the top third of the banner.”',
    });
  }
};
